import { useEffect, useState } from "react";
import { ShieldPlus, X, Plus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";

export default function InsurancesEditor() {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/doctors/me/insurances").then((r) => setItems(r.data.insurances || [])).catch(() => {});
  }, []);

  const persist = async (next) => {
    setBusy(true);
    try {
      const { data } = await api.put("/doctors/me/insurances", { insurances: next });
      setItems(data.insurances);
      toast.success("Seguros actualizados");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const add = (e) => {
    e.preventDefault();
    const v = text.trim();
    if (!v) return;
    if (items.some((i) => i.toLowerCase() === v.toLowerCase())) { toast.error("Ese seguro ya está agregado"); return; }
    setText("");
    persist([...items, v]);
  };

  return (
    <div className="rounded-2xl border border-[#E2E8F0] bg-white p-6" data-testid="insurances-editor">
      <div className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
        <ShieldPlus className="h-4 w-4 text-[#0284C7]" /> Seguros médicos aceptados
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {items.length === 0 && <p className="text-xs font-semibold text-slate-400">Aún no hay seguros agregados.</p>}
        {items.map((s) => (
          <span key={s} className="inline-flex items-center gap-1.5 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-bold text-emerald-700" data-testid={`insurance-chip-${s}`}>
            {s}
            <button type="button" disabled={busy} onClick={() => persist(items.filter((x) => x !== s))} className="text-emerald-500 hover:text-red-500" data-testid={`insurance-remove-${s}`}>
              <X className="h-3.5 w-3.5" />
            </button>
          </span>
        ))}
      </div>
      <form onSubmit={add} className="mt-3 flex gap-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Ej.: ARS Humano, SeNaSa, Universal…" className="rounded-xl border-[#E2E8F0]" data-testid="insurance-input" />
        <Button type="submit" disabled={busy || !text.trim()} className="rounded-full bg-[#0284C7] font-bold hover:bg-[#0369a1]" data-testid="insurance-add-btn">
          <Plus className="mr-1 h-4 w-4" /> Agregar
        </Button>
      </form>
    </div>
  );
}

export function InsuranceChips({ items, testid = "insurance-list" }) {
  if (!items || items.length === 0) return <span className="text-sm font-bold text-slate-800">—</span>;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      {items.map((s) => (
        <span key={s} className="rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-0.5 text-xs font-bold text-emerald-700">{s}</span>
      ))}
    </div>
  );
}
